import { FC } from 'react';

import { LmCheckbox, LmText } from '@mes-ui/lemma';

interface ISubjectCheckboxProps {
  value: string;
  isChecked: boolean;
  isDisabled: boolean;
  checkboxColor: string;
  labelColor: string;
  onToggle: () => void;
}

const SubjectCheckbox: FC<ISubjectCheckboxProps> = ({
  value,
  isChecked,
  isDisabled,
  checkboxColor,
  labelColor,
  onToggle,
}) => {
  return (
    <div
      className={
        isChecked ? 'performance-chart__subject performance-chart__subject--checked' : 'performance-chart__subject'
      }
      style={
        {
          '--subject-color': checkboxColor,
        } as React.CSSProperties
      }
    >
      <LmCheckbox
        checked={isChecked}
        disabled={isDisabled && !isChecked}
        onChange={onToggle}
        boxSize="large"
        className="performance-chart__checkbox"
      />
      <LmText color="note" variant="lg" className="performance-chart__subject-name" style={{ color: labelColor }}>
        {value}
      </LmText>
    </div>
  );
};

export default SubjectCheckbox;
